import { createHttpClient } from "@p-ban/common/src/core/api/createHttpClient"

import * as Sentry from "../lib/Sentry"
import { redirectToLogin } from "../logic/auth/returnUrl"
import { apiOrigin } from "./apiOrigin"

const httpClient = createHttpClient({
  origin: apiOrigin,
  onUnknownError: Sentry.captureException,
  onUnauthorizedError: redirectToLogin,
  onServerMaintenance() {
    // iframe内で呼ばれる場合も考慮しtopを指定してます。
    ;(window.top ?? window).location.assign("/kiban/maintenance.jsp")
  },
})

export default httpClient
